module.exports = __webpack_public_path__ + "static/media/homework-success-banner-right.fd78720e.png";